<template>
  <div class="wrapper">
    <div class="product-list" v-bind:class="{'product-list--2': view === 2}">
      <slot name="products" :view="view" :moduleCatalog="moduleCatalog"></slot>
      <catalog-product v-for="item in moduleCatalog.products" :info="item" :key="item.ID" :marketplaces="item.MARKETPLACES">
        <template v-slot:product="productSlotProps">
          <a class="product-card__link" :href="productSlotProps.link"></a>
          <div class="product-card__label">
            <div v-if="productSlotProps.info.DISCOUNT_PERCENT" class="product-card__label-item">Скидка {{
                productSlotProps.info.DISCOUNT_PERCENT
                                                                                                }}%
            </div>
            <div v-if="productSlotProps.info.NEW === 'Y'" class="product-card__label-item new">Новинка</div>
          </div>
          <div class="product-card__favorite" :class="{'active': productSlotProps.isFav}" @click="productSlotProps.addToFavs"></div>
          <div class="product-card__img" :class="{'filled': productSlotProps.info.PICTURE || productSlotProps.info.PICTURE_MOBILE}">
            <picture>
              <source media="(min-width: 768px)" :srcset="productSlotProps.info.PICTURE ? productSlotProps.info.PICTURE : ''">
              <source media="(max-width: 767px)" :srcset="productSlotProps.info.PICTURE_MOBILE ? productSlotProps.info.PICTURE_MOBILE : ''">
              <img :alt="productSlotProps.info.IMG_DESCR ? productSlotProps.info.IMG_DESCR : 'Изображение'" loading="lazy">
            </picture>
          </div>
          <div class="product-card__title">{{ productSlotProps.info.NAME }}</div>
          <div class="product-card__description">{{ productSlotProps.info.PREVIEW_TEXT }}</div>
          <div class="product-card__bottom">
            <div class="product-card__price">
              <div class="product-card__price-new" v-html="productSlotProps.info.PRICE ? new Intl.NumberFormat('ru-RU').format(Number(productSlotProps.info.PRICE)) + ' ₽' : ''"></div>
              <div v-if="productSlotProps.info.PRICE !== productSlotProps.info.OLD_PRICE" v-html="productSlotProps.info.OLD_PRICE ? new Intl.NumberFormat('ru-RU').format(Number(productSlotProps.info.OLD_PRICE)) + ' ₽' : ''" class="product-card__price-old"></div>
            </div>
            <div class="product-card__buttons">
              <div v-if="productSlotProps.marketplaces?.length" class="product-card__marketplaces">
                <component
                  v-for="marketplace in productSlotProps.marketplaces"
                  :is="marketplace.link ? 'a' : 'span'"
                  :key="marketplace.name"
                  :href="marketplace.link"
                  :target="marketplace.link ? '_blank' : null"
                  :title="marketplace.name"
                  class="product-card__marketplace"
                  :class="{'product-card__marketplace--split': marketplace.name === 'Яндекс Сплит'}"
                >
                  <img :src="marketplace.logo" :alt="marketplace.name" class="product-card__marketplace-logo">
                </component>
              </div>
              <div v-if="productSlotProps.info.AV_QUANTITY === '0' || !productSlotProps.info.AV_QUANTITY" class="product-card__empty">
                Нет в наличии
              </div>
              <div v-else-if="productSlotProps.inBasket" class="product-card__basket" :class="{'active': productSlotProps.inBasket}">
                <a class="product-card__basket-link" href="/basket/" title="Перейти в корзину"></a>
              </div>
              <div v-else class="product-card__basket" @click="productSlotProps.addToBasket"></div>
            </div>
          </div>
        </template>
      </catalog-product>
    </div>
    <slot v-if="!all" name="pagination" :loadMore="loadMore"></slot>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";
import CatalogProduct         from "./CatalogProduct.vue";

export default {
  name       : "CatalogProductsList",
  components : {CatalogProduct},
  props      : {
    pages      : Number,
    view       : Number,
    sort       : Number,
    sort_by    : String,
    sort_order : String,
    section    : Number,
    count      : Number,
    nav_num    : Number,
    filter     : [Array, Object],
    items      : Array
  },
  data()
  {
    return {
      page         : 2,
      all          : false,
      itemQuantity : 0
    };
  },
  computed : {
    ...mapState([
      "moduleCatalog"
    ])
  },
  methods  : {
    ...mapActions([
      "SET_PRODUCTS"
    ]),
    loadMore()
    {
      if(this.all) return;
      let query = (document.location.search === "" ? "?" : "&") + "pagination=Y&PAGEN_" + this.nav_num + "=" + this.page;
      fetch(document.location.href + query, {
        method : "GET"
      })
      .then(response => response.json())
      .then(result =>
      {
        if(result.data.length > 0)
        {
          this.SET_PRODUCTS(result.data);
        }
        this.page++;
        if(this.pages < this.page)
        {
          this.all = true;
        }
      });
    }
  },
  created()
  {
    this.all = this.pages < this.page;
  }
};
</script>